import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router';
import { withRouter } from 'react-router-dom';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import { connect } from 'react-redux';
import NotificationsSystem from '@mrlannigan/reapop';
import ggtheme from 'styles/reapop-theme-goodway';

// Route Components
import LoginPage from 'components/pages/Login';
import SummaryDashboard from 'components/pages/dashboards/Summary';
import DisplayDashboard from 'components/pages/dashboards/Display';
import VideoDashboard from 'components/pages/dashboards/Video';
import TVDashboard from 'components/pages/dashboards/TV';
import YouTubeDashboard from 'components/pages/dashboards/Youtube';
import SiteDirectDashboard from 'components/pages/dashboards/SiteDirect';
import MobileDashboard from 'components/pages/dashboards/Mobile';
import NativeDashboard from 'components/pages/dashboards/Native';
import SEMDashboard from 'components/pages/dashboards/SEM';
import AudioDashboard from 'components/pages/dashboards/Audio';
import SocialDashboard from 'components/pages/dashboards/Social';
import CustomDashboard from 'components/pages/dashboards/Custom';
import { CreateBrand, EditBrand, ListBrands, ViewBrand, EditBrandBranding, EditBrandAdvancedOptions } from 'components/pages/admin/brands';
import { CreateUser, EditUser, ListUsers, ViewUser } from 'components/pages/admin/users';
import { CreateCapabilityGroups, EditCapabilityGroups, ListCapabilityGroups, ViewCapabilityGroups } from 'components/pages/admin/capabilityGroups';
import { ListOffers } from 'components/pages/admin/offers';
import { ListDynamicProfiles, ViewDynamicProfile, CreateDynamicProfile, EditDynamicProfile } from 'components/pages/admin/dynamicProfiles';
import EditEntity from 'components/pages/admin/entities/EditEntity';
import CreateEntity from 'components/pages/admin/entities/CreateEntity';
import ViewEntity from 'components/pages/admin/ViewEntity';
import ListEntities from 'components/pages/admin/ListEntities';
import ViewAnnotation from 'components/pages/admin/annotations/ViewAnnotation';
import ListAnnotations from 'components/pages/admin/annotations/ListAnnotations';
import CreatePasswordPage from 'components/pages/CreatePassword';
import ResetPasswordPage from 'components/pages/ResetPassword';
import HomeIndexPage from 'components/pages/home/HomeIndex';
import G90IndexPage from 'components/pages/home/G90Index';
import GlossaryIndexPage from 'components/pages/home/GlossaryIndex';
import AdminIndexPage from 'components/pages/home/AdminIndex';
import LabRealValue from 'components/pages/labs/LabRealValue';
import LabATVLift from 'components/pages/labs/LabATVLift';
import LabCrossChannel from 'components/pages/labs/LabCrossChannel';
import LabHyperlocal from 'components/pages/labs/LabHyperlocal';
import LabGeo from 'components/pages/labs/LabGeo';
import LabsIndexPage from 'components/pages/labs/LabsIndex';
import OktaReceiverPage from 'components/pages/admin/OktaReceiver';
import NotFound from 'components/pages/NotFound';
import KeyCatcherContainer from 'containers/KeyCatcherContainer';
import FullStoryContainer from 'containers/FullStoryContainer';
import ForceSSOLoginContainer from 'containers/ForceSSOLoginContainer';
import SubSiteRedirect from 'components/pages/SubSiteRedirect';
import SmartguardScoreboardPage from 'components/pages/admin/smartguard/Scoreboard';
import DuplicateRedashDashboardPage from 'components/pages/admin/redash/DuplicateRedashDashboardPage';
import { getGoodlookURL } from 'helpers/goodlook';
import { getQAUrl } from 'helpers/qa';

// Global style
const GlobalStyle = createGlobalStyle`
  body {
    background-color: #fff;
    color: #656158;
    font-family: 'Lato', sans-serif;
  }

  .highcharts-container {
    width:100% !important;
    height:100% !important;
}
`;

class App extends Component {
    render() {
        return (
            <ThemeProvider theme={this.props.theme}>
                <React.Fragment>
                    <FullStoryContainer />
                    <KeyCatcherContainer />
                    <NotificationsSystem theme={ggtheme} />
                    <GlobalStyle />
                    <Switch>
                        <Route exact path="/" component={G90IndexPage} />
                        <Route exact path="/dashboard" component={HomeIndexPage} />
                        <Route exact path="/home" render={() => <Redirect to="/" />} />
                        <Route exact path="/admin" component={AdminIndexPage} />
                        <Route exact path="/glossary" component={() => <Redirect to="/dashboard/glossary" />} />
                        <Route exact path="/dashboard/glossary" component={GlossaryIndexPage} />
                        <Route exact path="/dashboard/:entityId/labs/geo" component={LabGeo} />
                        <Route exact path="/dashboard/:entityId/labs/realvalue" component={LabRealValue} />
                        <Route exact path="/dashboard/:entityId/labs/cross-channel" render={location => <Redirect to={`/dashboard/${location.match.params.entityId}/labs/cross-channel/atv`} />} />
                        <Route exact path="/dashboard/:entityId/labs/cross-channel/atv" component={LabATVLift} />
                        <Route exact path="/dashboard/:entityId/labs/cross-channel/all" component={LabCrossChannel} />
                        <Route exact path="/dashboard/:entityId/labs/hyperlocal" component={LabHyperlocal} />
                        <Route exact path="/dashboard/:entityId/labs" component={LabsIndexPage} />
                        <Route exact path="/login" component={LoginPage} />
                        <Route exact path="/login/forgot-password" component={ResetPasswordPage} />
                        <Route exact path="/dashboard/:entityId" render={location => <Redirect to={`/dashboard/${location.match.params.entityId}/summary`} />} />
                        <Route exact path="/dashboard/:entityId/summary" component={SummaryDashboard} />
                        <Route exact path="/dashboard/:entityId/tactic/display" render={location => <Redirect to={`/dashboard/${location.match.params.entityId}/channel/display`} />} />
                        <Route exact path="/dashboard/:entityId/channel/display" component={DisplayDashboard} />
                        <Route exact path="/dashboard/:entityId/tactic/video" render={location => <Redirect to={`/dashboard/${location.match.params.entityId}/channel/video`} />} />
                        <Route exact path="/dashboard/:entityId/channel/video" component={VideoDashboard} />
                        <Route exact path="/dashboard/:entityId/channel/tv" component={TVDashboard} />
                        <Route exact path="/dashboard/:entityId/channel/youtube" component={YouTubeDashboard} />
                        <Route exact path="/dashboard/:entityId/tactic/mobile" render={location => <Redirect to={`/dashboard/${location.match.params.entityId}/channel/mobile`} />} />
                        <Route exact path="/dashboard/:entityId/channel/mobile" component={MobileDashboard} />
                        <Route exact path="/dashboard/:entityId/channel/native" component={NativeDashboard} />
                        <Route exact path="/dashboard/:entityId/channel/sem" component={SEMDashboard} />
                        <Route exact path="/dashboard/:entityId/channel/audio" component={AudioDashboard} />
                        <Route exact path="/dashboard/:entityId/channel/social" component={SocialDashboard} />
                        <Route exact path="/dashboard/:entityId/channel/custom" component={CustomDashboard} />
                        <Route exact path="/dashboard/:entityId/embed/:slug" component={CustomDashboard} />
                        <Route exact path="/dashboard/:entityId/channel/site" component={SiteDirectDashboard} />
                        <Route exact path="/account/confirm" component={CreatePasswordPage} />
                        <Route exact path="/admin/login" component={ForceSSOLoginContainer} />
                        <Route exact path="/admin/annotations" component={ListAnnotations} />
                        <Route exact path="/admin/annotations/:id" component={ViewAnnotation} />
                        <Route exact path="/admin/brands" component={ListBrands} />
                        <Route exact path="/admin/brands/create" component={CreateBrand} />
                        <Route exact path="/admin/brands/:id" component={ViewBrand} />
                        <Route exact path="/admin/brands/:id/edit" component={EditBrand} />
                        <Route exact path="/admin/brands/:id/branding" component={EditBrandBranding} />
                        <Route exact path="/admin/brands/:id/options" component={EditBrandAdvancedOptions} />
                        <Route exact path="/admin/dynamic-profiles" component={ListDynamicProfiles} />
                        <Route exact path="/admin/dynamic-profiles/create" component={CreateDynamicProfile} />
                        <Route exact path="/admin/dynamic-profiles/:id" component={ViewDynamicProfile} />
                        <Route exact path="/admin/dynamic-profiles/:id/edit" component={EditDynamicProfile} />
                        <Route exact path="/admin/offers/" component={ListOffers} />
                        <Route exact path="/admin/okta-receive" component={OktaReceiverPage} />
                        <Route exact path="/admin/users" component={ListUsers} />
                        <Route exact path="/admin/users/create" component={CreateUser} />
                        <Route exact path="/admin/users/:id/edit" component={EditUser} />
                        <Route exact path="/admin/users/:id" component={ViewUser} />
                        <Route exact path="/admin/entities" component={ListEntities} />
                        <Route exact path="/admin/entities/create" component={CreateEntity} />
                        <Route exact path="/admin/entities/:id" component={ViewEntity} />
                        <Route exact path="/admin/entities/:id/edit" component={EditEntity} />
                        <Route exact path="/admin/capability-groups" component={ListCapabilityGroups} />
                        <Route exact path="/admin/capability-groups/create" component={CreateCapabilityGroups} />
                        <Route exact path="/admin/capability-groups/:id" component={ViewCapabilityGroups} />
                        <Route exact path="/admin/capability-groups/:id/edit" component={EditCapabilityGroups} />
                        <Route exact path="/admin/smartguard/scoreboard" component={SmartguardScoreboardPage} />
                        <Route exact path="/admin/redash/duplicate" component={DuplicateRedashDashboardPage} />
                        <Route exact path="/generate-error" component={() => {
                            throw new Error(`Today is ${(new Date().toLocaleDateString('en-US'))} and this is an intentional error`);
                        }} />

                        {/*
                            NOTE: Redirect all traffic to campaign-engine that hits this app with a
                            hard redirect to force a reload of the page.
                        */}
                        <Route path="/unicorn" render={() => <SubSiteRedirect hostEnvName="REACT_APP_UNICORN_HOST" />} />
                        <Route path="/campaign-engine" render={() => <SubSiteRedirect hostEnvName="REACT_APP_UNICORN_HOST" />} />
                        <Route path="/order-fulfillment" render={() => <SubSiteRedirect hostEnvName="REACT_APP_ORDER_FULFILLMENT_HOST" />} />
                        <Route path="/pixel-qa" render={() => <SubSiteRedirect hostEnvName="REACT_APP_PIXEL_QA_HOST" />} />
                        <Route path="/goodlook" render={() => { window.location.replace(getGoodlookURL()); return <React.Fragment></React.Fragment>; }} />
                        <Route path="/qa" render={() => { window.location.replace(getQAUrl()); return <React.Fragment></React.Fragment>; }} />
                        <Route path="/product-manager" render={() => <SubSiteRedirect hostEnvName="REACT_APP_PRODUCT_MANAGER_HOST" />} />
                        <Route path="/rmn-portal" render={() => <SubSiteRedirect hostEnvName="REACT_APP_PRODUCT_MANAGER_HOST" />} />
                        <Route component={NotFound} />
                    </Switch>
                </React.Fragment>
            </ThemeProvider>
        );
    }
}

const mapStateToProps = state => ({
    theme: state.theme
});

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js